import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useTabGroup } from '../../commonDesign/SydTabs/tabContext'
import OpalItemPicker from '../OpalItemPicker'

function OpalTabSelect ({ showIcon, className, style }) {
  const { selectedValue, selectValue, options } = useTabGroup()
  const pickerOptions = useMemo(() => {
    return options.map(opt => ({
      ...opt.payload
    }))
  }, [options])

  return (
    <div className='flex'>
      <OpalItemPicker
        options={pickerOptions}
        value={selectedValue}
        showIcon={showIcon}
        onSelect={(option) => selectValue(option.value)}
        className={clsx('flex gap-2 items-center opal-surface-default hover select-none', className)}
        style={style}
      />
    </div>
  )
}

OpalTabSelect.propTypes = {
  showIcon: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object
}

OpalTabSelect.defaultProps = {
  showIcon: true
}

export default OpalTabSelect
